import './BecomeSeller.css';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { addSellerRole } from '../../utils/api';
import { refresh } from '../../services/auth.service';
import Spinner from '../../components/layout/Spinner';

function BecomeSeller() {
  const [loaded, setLoaded] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setLoaded(true);
    }, 2000);
  }, []);

  async function handleJoin(){
    setSubmitting(true);
    let res = await addSellerRole();

    if (res.success){
      setTimeout(() => {
        setSubmitting(false);
        setShowConfirmation(true);
        localStorage.setItem('current_view', 'Seller');
      }, 4000);
    }

    else if (res.status === 403){
      await refresh();
      let res = await addSellerRole();

      if (res.success){
        setTimeout(() => {
          setSubmitting(false);
          setShowConfirmation(true);
          localStorage.setItem('current_view', 'Seller');
        }, 4000);
      }
    }
  }

  return (
    <>
      <Helmet>
        <title>LeadrPro - Become a seller</title>
      </Helmet>

      <div className='becomeseller'>
        <div className='becomeseller__window'>
          {loaded === false && (
            <div className='center'>
              <Spinner />
            </div>
          )}

          {loaded && (
            <>
              <h1>Join the marketplace</h1>

              <p>
                Looking to fill your sales funnel quickly with high quality leads? Setup your LeadrPro seller account and get started for free. Once you sign up you will be able to:
              </p>

              <ul>
                <li>Create your free public company profile page</li>
                <li>Browse through 1000's of potential leads</li>
                <li>Get qualified answers to your specific questions</li>
                <li>Only pay for the meetings you approve and book</li>
              </ul>

              <div className='becomeseller__btns'>
                {submitting === false && (
                <button className='btn btn--primary' onClick={() => handleJoin()}>Join the marketplace</button>
                )}

                {submitting && (
                  <Spinner />
                )}

                <br/>
                <Link to='/account/workspace' className='link'>{'< Back to Workspace'}</Link>
              </div>
            </>
          )}
        </div>
      </div>

      {showConfirmation && (
        <>
          <div className='overlay'></div>
          <div className='modal'>
            <h2 className='modal__h2'>Success!</h2>

            <p>
              You now have access to the seller workspace, where you can update your company's profile, configure your ideal candidate profile and get custom recommendations suited to you.
            </p>

            <p>
              You only pay for demos that you successfully approve and book.
            </p>

            <div className='mar20--top center'>
              <Link to='/account/workspace' className='link'>Take me to my Workspace</Link>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default BecomeSeller;
